export default {
      id: "ic-top-usage",
      viewBox: "0 0 50 50",
      url: "../dist/images/" + "sprite.svg#ic-top-usage",
      toString: function () {
        return this.url;
      }
    }